export default __webpack_public_path__ + "static/media/reg_img.19f9eeff.svg";